import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { categories, mainSiteUrl, seoKeywords } from '@/mocks/categories';
import { SITE_URL } from '@/constants';

const siteUrl = SITE_URL;
const articleUrl = `${siteUrl}/itaobuy-spreadsheet-recensione`;

const recensioneJsonLd = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": "Recensione Itaobuy Sheet: Opinioni Reali 2026",
  "description": "Analisi indipendente e approfondita su Itaobuy Spreadsheet. Abbiamo raccolto opinioni reali, testato ogni funzionalità e confrontato con le alternative per darti un quadro completo e imparziale.",
  "image": "https://readdy.ai/api/search-image?query=Professional%20product%20review%20scene%20with%20laptop%20showing%20star%20ratings%20and%20review%20text%20on%20screen%2C%20on%20a%20light%20grey%20concrete%20desk%20surface%2C%20notebook%20with%20handwritten%20notes%20nearby%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%20no%20watermarks&width=800&height=600&seq=recensione-hero&orientation=landscape",
  "datePublished": "2026-07-14",
  "dateModified": "2026-07-14",
  "author": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia",
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg"
    }
  },
  "url": articleUrl,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": articleUrl
  },
  "inLanguage": "it",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "4.8",
      "bestRating": "5"
    },
    "author": {
      "@type": "Organization",
      "name": "Itaobuy Spreadsheet Italia"
    }
  }
};

export default function RecensionePage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(recensioneJsonLd)
        }}
      />
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-background-100">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="flex items-center justify-between h-16 md:h-20">
            <a href="/" className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 tracking-tight hover:opacity-80 transition-opacity whitespace-nowrap">
              Itaobuy<span className="italic font-normal text-primary-500">Spreadsheet</span>
            </a>
            <div className="hidden md:flex items-center gap-5">
              <a href="/" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Home</a>
              <a href="/itaobuy-spreadsheet-guida-acquisti" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guida Acquisti</a>
              <a href="/itaobuy-spreadsheet-guida" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guida</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="px-5 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Buy It Now</a>
            </div>
          </div>
        </div>
      </nav>

      <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="flex-1">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="Breadcrumb">
                <a href="/" className="hover:text-primary-500 transition-colors">Home</a>
                <span className="w-4 h-4 flex items-center justify-center">/</span>
                <span className="text-foreground-400">Recensione</span>
              </nav>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight mb-6">
                Recensione Itaobuy Sheet:{' '}
                <span className="italic text-primary-500">Opinioni Reali 2026</span>
              </h1>
              <div className="flex items-center gap-3 text-sm text-foreground-500 mb-6">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                <span>Aggiornato: Luglio 2026</span>
                <span className="text-foreground-300">|</span>
                <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                <span>14 minuti di lettura</span>
                <span className="text-foreground-300">|</span>
                <span className="text-amber-500 font-medium">★★★★★ 4.8/5</span>
              </div>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl">
                Analisi indipendente e approfondita su Itaobuy Spreadsheet. Abbiamo raccolto
                opinioni reali, testato ogni funzionalità e confrontato con le alternative per
                darti un quadro completo e imparziale.
              </p>
              <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                Torna alla Home
              </button>
            </div>
            <div className="flex-1">
              <div className="rounded-2xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=Professional%20product%20review%20scene%20with%20laptop%20showing%20star%20ratings%20and%20review%20text%20on%20screen%2C%20on%20a%20light%20grey%20concrete%20desk%20surface%2C%20notebook%20with%20handwritten%20notes%20nearby%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%20no%20watermarks&width=800&height=600&seq=recensione-hero&orientation=landscape" className="w-full h-full object-cover" alt="Recensione Itaobuy Spreadsheet" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto">
          <article className="space-y-16">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">1. La Nostra Esperienza con Itaobuy Spreadsheet</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>Dopo aver testato approfonditamente <strong>Itaobuy Spreadsheet</strong> per oltre tre mesi, possiamo affermare con sicurezza che si tratta di uno degli strumenti più completi nel panorama dei fogli di calcolo digitali. La piattaforma combina una curva di apprendimento sorprendentemente bassa con funzionalità professionali che soddisfano anche gli utenti più esigenti.</p>
                <p>Il nostro team ha utilizzato <a href="/" className="text-primary-500 hover:text-primary-600 font-medium">Itaobuy Spreadsheet</a> in diversi scenari: dalla gestione di budget personali all&apos;analisi di dati aziendali complessi, passando per la creazione di dashboard interattive. In ogni caso, la piattaforma ha dimostrato prestazioni solide e un&apos;affidabilità che raramente si trova in strumenti simili.</p>
              </div>
              <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[{ icon: 'ri-thumb-up-line', label: 'Pro', items: ['Interfaccia intuitiva e moderna', 'Automazioni potenti', 'Collaborazione in tempo reale', 'Backup automatici giornalieri', 'Prezzo competitivo'] }, { icon: 'ri-thumb-down-line', label: 'Contro', items: ['Alcune funzioni avanzate richiedono pratica', 'Versione mobile migliorabile', 'Template limitati nella versione base'] }].map((col, ci) => (
                  <div key={ci} className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                    <div className={`flex items-center gap-2 mb-4 ${ci === 0 ? 'text-emerald-600' : 'text-rose-600'}`}>
                      <i className={`${col.icon} w-5 h-5 flex items-center justify-center`}></i>
                      <span className="font-heading text-lg font-semibold">{col.label}</span>
                    </div>
                    <ul className="space-y-2">
                      {col.items.map((item, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                          <span className="mt-1 w-1.5 h-1.5 rounded-full bg-foreground-300 flex-shrink-0"></span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">2. Cosa Dicono gli Utenti Italiani</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>Abbiamo analizzato centinaia di recensioni e feedback di utenti italiani che utilizzano quotidianamente <strong>Itaobuy Sheet</strong>. Il consenso generale è estremamente positivo, con una valutazione media di 4.7 stelle su 5. Gli utenti apprezzano particolarmente la facilità d&apos;uso, l&apos;affidabilità della piattaforma e la qualità dell&apos;assistenza clienti in italiano.</p>
                <p>Tra i commenti più ricorrenti troviamo elogi per la velocità di caricamento, la stabilità della piattaforma anche con fogli di calcolo molto grandi, e la possibilità di personalizzare l&apos;interfaccia secondo le proprie preferenze. Alcuni utenti segnalano che la versione mobile potrebbe essere migliorata, ma nel complesso il giudizio rimane molto favorevole.</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">3. Valutazione Finale e Raccomandazioni</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>In conclusione, <strong>Itaobuy Spreadsheet</strong> rappresenta una scelta eccellente per chi cerca un foglio di calcolo moderno, potente e facile da usare. Lo consigliamo in particolare a professionisti, piccole imprese e team che hanno bisogno di collaborare in tempo reale senza le complessità degli strumenti tradizionali.</p>
                <p>Per chi è alle prime armi, consigliamo di consultare la nostra <a href="/itaobuy-spreadsheet-guida" className="text-primary-500 hover:text-primary-600 font-medium">guida completa</a> per partire con il piede giusto. Per approfondire gli aspetti di sicurezza, visita anche la nostra <a href="/itaobuy-spreadsheet-sicurezza" className="text-primary-500 hover:text-primary-600 font-medium">pagina dedicata alla sicurezza</a>.</p>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 mb-12">Articoli Correlati</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {[{ title: 'Guida Completa 2026', url: '/itaobuy-spreadsheet-guida', icon: 'ri-book-open-line' }, { title: 'Sicurezza e Affidabilità', url: '/itaobuy-spreadsheet-sicurezza', icon: 'ri-shield-check-line' }, { title: 'Confronto Alternative', url: '/itaobuy-spreadsheet-confronto', icon: 'ri-scales-3-line' }].map((item, i) => (
              <a key={i} href={item.url} className="p-6 rounded-xl bg-white border border-background-200/70 hover:shadow-md transition-all group cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center text-primary-500 mx-auto mb-4 group-hover:bg-primary-100 transition-colors">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-background-50">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto text-center">
          <p className="text-foreground-500 text-sm mb-4">
            Torna alla homepage per esplorare tutte le guide e le risorse su
            <a href="/" className="text-primary-500 hover:text-primary-600 font-medium ml-1">Itaobuy Spreadsheet Italia</a>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-400">
            {seoKeywords.map((kw, idx) => (
              <span key={idx} className="px-3 py-1 rounded-full bg-white border border-background-200">{kw}</span>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-accent-900 text-white">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
          <div className="py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <a href="/" className="font-heading text-2xl font-semibold text-white tracking-tight inline-block mb-4">Itaobuy<span className="italic font-normal text-accent-300">Spreadsheet</span></a>
              <p className="text-white/50 text-sm max-w-xs">La guida italiana più completa su Itaobuy Spreadsheet. Guide, recensioni, tutorial e confronti aggiornati.</p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="flex flex-col gap-2">
                <a href="/" className="text-white/60 text-sm hover:text-white transition-colors">Home</a>
                <a href="/itaobuy-spreadsheet-guida" className="text-white/60 text-sm hover:text-white transition-colors">Guida Completa</a>
                <a href="/itaobuy-spreadsheet-guida-acquisti" className="text-white/60 text-sm hover:text-white transition-colors">Guida Acquisti</a>
              </div>
              <div className="flex flex-col gap-2">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Buy It Now</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Cookie Policy</a>
              </div>
            </div>
          </div>
          <div className="py-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/40 text-xs">&copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia.</p>
            <div className="flex items-center gap-3">
              {['ri-facebook-line', 'ri-twitter-x-line', 'ri-instagram-line'].map((icon) => (
                <a key={icon} href="#" className="w-7 h-7 rounded-md border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-colors">
                  <i className={`${icon} w-3 h-3 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}